import { render, staticRenderFns } from "./AttachmentsPreview.vue?vue&type=template&id=241684f0&"
import script from "./AttachmentsPreview.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttachmentsPreview.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241684f0')) {
      api.createRecord('241684f0', component.options)
    } else {
      api.reload('241684f0', component.options)
    }
    module.hot.accept("./AttachmentsPreview.vue?vue&type=template&id=241684f0&", function () {
      api.rerender('241684f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/AttachmentsPreview.vue"
export default component.exports